export const sectionWrapperStyle = {
  background: "#FAFBFE",
  marginBottom: "6rem",
};

export const sectionHeadingStyle = {
  fontSize: 40,
  textAlign: "center",
  fontWeight: 700,
  padding: "20rem 20rem 0 20rem",
  lineHeight: "3.5rem",
};

export const cardActiveStyle = {
  background: "#2D1C6F",
  borderRadius: "1.5rem",
  padding: "2.5rem",
  color: "#ffffff",
  transition: ".3s",
};

export const cardAbbreviationStyle = {
  fontSize: 18,
  fontWeight: 500,
  color: "#BFB5D3",
  marginTop: ".5rem",
};

export const cardInactiveStyle = {
  background: "#ffffff",
  borderRadius: "1.5rem",
  padding: "2.5rem",
  transition: ".3s",
};
